import type { BoundClientMethods, ClientContext } from './types'
import { request } from './request'
import * as UnboundMethods from './methods'

type CreateEngineClientOptions = {
  baseUrl: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  env?: Record<string, any>
  getToken?: () => Promise<string> | string | null | undefined
}

function createContext(config: CreateEngineClientOptions) {
  const context = {
    // default value
    baseUrl: 'https://api.getcircuit.com/rest/',
  } as unknown as ClientContext

  const boundRequest = request.bind(undefined, context)

  Object.assign(context, {
    baseUrl: config.baseUrl.replace(/\/$/, ''),
    getToken: config.getToken,
    env: config.env ?? {},
    request: boundRequest,
  })

  return context
}

function bindMethods(
  methods: typeof UnboundMethods,
  context: ClientContext,
): BoundClientMethods {
  return Object.entries(methods).reduce((acc, [name, fn]) => {
    // this is for testing only, because babel-jest
    // adds a _esModule property here :shrug:
    if (typeof fn !== 'function') return acc

    const key = name as keyof typeof UnboundMethods

    // @ts-expect-error - Ts doesn't know how to link fn to key correctly
    acc[key] = fn.bind(undefined, context)

    return acc
  }, {} as BoundClientMethods)
}

export function createEngineClient(options: CreateEngineClientOptions) {
  const context = createContext(options)

  // bind methods to the client's context
  const boundMethods = bindMethods(UnboundMethods, context)

  return Object.freeze({
    request: context.request,
    ...boundMethods,
  })
}

export {
  createStop,
  mapAddressSearchResultItemToStop,
} from './methods/Address/utils'
